<template>
	<div class="base-input" :class="{ 'border': showBorder }">
		<van-field v-bind="$attrs" v-on="$listeners" />
	</div>
</template>

<script>
	export default {
		name: 'BaseInput',
		props: {
			showBorder: {
				type: Boolean,
				default: false
			}
		}
	};
</script>

<style scoped lang="less">
	.base-input {
		&.border {
			border-bottom: 1px solid #DEE0E3;
		}
		.van-cell {
			padding: 28px 0;
			font-size: 40px;
			font-family: PingFangSC-Regular;
			font-weight: normal;
		}
	}
</style>
